import React, { useState, useEffect } from "react";
import Axios from "axios";
import "react-accessible-accordion/dist/fancy-example.css";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import FileUploadCard from "./FileUploadCardInvoice";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import { Activity, currentRequestTimeStamp } from "../../../../Constants";
import { validateAndReadFile } from "../../../CompanyProfileNew/FreightMaster/Utility/utility";
import { useIndentTracking } from "../../hooks/useIndentTracking";

const UploadPOD = ({
  indent,
  getData,
  getVehicleTracking,
  skipactive,
  sendMail1,
}) => {
  const { trackIndentEvent } = useIndentTracking();

  useEffect(() => {
    // Track the click event for uploading POD/Invoice
    trackIndentEvent(
      "indent tracking",
      "user has clicked on pod/invoice upload button",
      `Indent : ${indent.indent_id}`,
      `Vehicle Sub Id : ${indent.vehicle.indent_id_sub}`
    );
  }, []);

  // State hooks for managing files and loader visibility
  const [pods, setPods] = useState([]); // Array to store POD files
  const [invoices, setInvoice] = useState([]); // Array to store Invoice files
  const [lrs, setLrs] = useState([]); // Array to store LR files
  const [show, setShow] = useState(false); // Boolean to manage loader visibility

  // Effect hook to populate file lists from indent data
  useEffect(() => {
    const podList = [];
    const invoiceList = [];
    const lrList = [];

    if (indent.vehicle.file_uploads) {
      // Categorize files based on their type
      indent.vehicle.file_uploads.forEach((f) => {
        if (f.type === "pod") {
          podList.push(f);
        } else if (f.type === "invoice") {
          invoiceList.push(f);
        } else if (f.type === "lr") {
          lrList.push(f);
        }
      });
    }

    setPods(podList);
    setInvoice(invoiceList);
    setLrs(lrList);
  }, [indent.vehicle.file_uploads]);

  const removeFile = (file, type, remarks) => {
    const payload = {
      filePath: file.filePath,
      fileName: file.fileName,
      fileUrl: file.fileUrl,
      indent_id_sub: indent.vehicle.indent_id_sub,
      type: type,
      lr_id: indent?.vehicle?.lr_ids?.[0],
      uploaded_by: file.uploaded_by,
      remarks: remarks,
    };

    axios
      .put(
        `${Urls.indent}?indent_id=${indent.indent_id}&indent_id_sub=${indent.vehicle.indent_id_sub}&field=file_deletion`,
        payload
      )
      .then((res) => {
        toast.success("File removed successfully");
        if (type === "pod") {
          setPods((prev) => prev.filter((f) => f.fileName !== file.fileName));
        } else if (type === "invoice") {
          setInvoice((prev) =>
            prev.filter((f) => f.fileName !== file.fileName)
          );
        } else if (type === "lr") {
          setLrs((prev) => prev.filter((f) => f.fileName !== file.fileName));
        }
        getData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // let podarry = pods;
  // let invoicearry = invoices;
  // let podlastElement = podarry[podarry.length - 1];
  // let invoicelastElement = invoicearry[invoicearry.length - 1];
  /**
   * Handles file uploads and updates the indent data.
   * @param {FileList} e - List of selected files.
   * @param {Object} indent - The current indent object.
   * @param {string} type - The type of file being uploaded ("pod" or "invoice").
   * @returns {Promise} - A promise that resolves when the upload is complete.
   */
  const UploadFiles = async (e, indent, type) => {
    const selectedFile = e[0];
    const file_uploads = [];

    // validations
    const result = await validateAndReadFile(selectedFile, ["image", "pdf", "excel"]);

    if (result.error) {
      toast.error(result.error);
      return false;
    }

    setShow(true);

    Activity([
      {
        screen: "Indents",
        module: "Vehicle Tracking",
        user_activity: `Upload POD/Invoice Clicked`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    let userFiles = [];
    const oid = localStorage.getItem("oid");
    const timestamp = Date.now();

    for (let i = 0; i < e.length; i++) {
      userFiles.push({
        filePath: `company/${oid}/${indent.indent_id}/${indent.vehicle.indent_id_sub
          }/${oid}-${timestamp}-${e[i]["name"].replace(/ /g, "-")}`,
        fileName: e[i]["name"],
        fileData: e[i],
        type: type,
      });
    }

    let fileList;

    if (type === "pod") {
      fileList = pods;
      setPods(userFiles);
    } else if (type === "invoice") {
      fileList = invoices;
      setInvoice(userFiles);
    }

    if (fileList) {
      userFiles.forEach((file) => {
        file_uploads.push(file);
      });
    }

    indent.vehicle.file_uploads = file_uploads;

    return new Promise((resolve, reject) => {
      if (userFiles.length > 0) {
        // Upload files to storage
        let totalFilesUploaded = 0;
        let totalFilesToUpload = userFiles.length;
        userFiles.map((file) => {
          let body = {
            fileName: file["filePath"],
            accountName: "lnclientdata",
            containerName: "indent-uploads",
            action: "upload",
          };

          Axios.post(Urls.fileService, body)
            .then((res1) => {
              // console.log(res.data)
              // Call `PUT` request for uploading file to storage with url recieved from API
              Axios.put(res1.data.url, file["fileData"], {
                headers: {
                  "x-ms-blob-type": "blockblob",
                  "x-ms-blob-content-disposition": file["fileData"]["type"],
                },
              })
                .then((res) => {
                  totalFilesUploaded += 1;
                  if (totalFilesUploaded === totalFilesToUpload) {
                    if (type === "pod") {
                      const payload = [
                        {
                          fileUrl: res1.data.url,
                          type,
                          filePath: res1.data.file_name,
                          fileName: file.fileName,
                          file_type: "uploaded",
                          uploaded_by: "company",
                          lr_id: indent?.vehicle?.lr_ids?.[0],
                        },
                      ];

                      axios
                        .put(
                          `${Urls.indent}?indent_id=${indent.indent_id}&indent_id_sub=${indent.vehicle.indent_id_sub}&field=file_upload`,
                          payload
                        )
                        .then(() => {
                          setPods((prevPods) => [...prevPods, payload]);
                          getVehicleTracking(skipactive, 10, 0);
                          setShow(false);
                        })
                        .catch((e) => {
                          console.error("Error uploading file:", e);
                          setShow(false);
                        });

                      toast.success("POD uploaded");
                      resolve({
                        status: "success",
                      });
                    } else if (type === "invoice") {
                      const payload = [
                        {
                          fileUrl: res1.data.url,
                          type,
                          filePath: res1.data.file_name,
                          fileName: file.fileName,
                          file_type: "uploaded",
                          uploaded_by: "company",
                          lr_id: indent?.lr_details?.[0]?.lr_id,
                        },
                      ];

                      axios
                        .put(
                          `${Urls.indent}?indent_id=${indent.indent_id}&indent_id_sub=${indent.vehicle.indent_id_sub}&field=file_upload`,
                          payload
                        )
                        .then(() => {
                          // Handle the logic for invoice upload
                          getVehicleTracking(skipactive, 10, 0);
                          setShow(false);
                        })
                        .catch((e) => {
                          console.error("Error uploading file:", e);
                          setShow(false);
                        });

                      toast.success("Invoice uploaded");
                      resolve({
                        status: "success",
                      });
                    }
                  }
                })
                .catch((error) => {
                  toast.error("Error while uploading your attachments");
                  console.log(error);
                  setShow(false);
                });
            })
            .catch((error) => {
              console.log(error);
              setShow(false);
              reject({
                status: "failed",
                message: error,
              });
            });
          return null;
        });

        toast.success("File Uploaded Successfully");
        Activity([
          {
            screen: "Indents",
            module: "Vehicle Tracking",
            user_activity: `File Upload Success`,
            timestamp: currentRequestTimeStamp(),
          },
        ]);
        trackIndentEvent(
          "indent tracking",
          "user has uploaded pod/invoice successfully",
          `Indent : ${indent.indent_id}`,
          `Vehicle Sub Id : ${indent.vehicle.indent_id_sub}`
        );
      } else {
        resolve({ status: "success" });
      }
    });
  };

  return (
    <>
      {/* <Loader show={show} /> */}
      <div className="row text-center">
        <div className="col-md-4">
          <div style={{ fontSize: "16px", fontWeight: "bolder" }}>Invoice:</div>
          {/* <FileUploadCard md={md} name={"POD"} uploadHandler={UploadFiles} files={pod}/> */}
          <FileUploadCard
            name={"Invoice"}
            files={invoices}
            indent={indent}
            uploadFiles={UploadFiles}
            indent_id_sub={indent.vehicle.indent_id_sub}
            indentId={indent.indent_id}
            type="invoice"
            getData={getData}
            show={show}
            onDelete={removeFile}
            disableUpload={true}
          />
        </div>
        <div className="col-md-4">
          <div style={{ fontSize: "16px", fontWeight: "bolder" }}>POD:</div>
          <FileUploadCard
            name={"POD"}
            files={pods}
            uploadFiles={UploadFiles}
            indent={indent}
            indent_id_sub={indent.vehicle.indent_id_sub}
            indentId={indent.indent_id}
            type="pod"
            getData={getData}
            show={show}
            onDelete={removeFile}
            disableUpload={indent?.is_cancelled?.status}
          />
        </div>
        <div className="col-md-4">
          <div style={{ fontSize: "16px", fontWeight: "bolder" }}>LR:</div>
          <FileUploadCard
            name={"LR"}
            files={lrs}
            uploadFiles={UploadFiles}
            indent={indent}
            indent_id_sub={indent.vehicle.indent_id_sub}
            indentId={indent.indent_id}
            type="lr"
            getData={getData}
            show={show}
            onDelete={removeFile}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between px-4 mt-5">
        <button
          className="btn btn-sm btn-success"
          onClick={(e) => sendMail1(indent, "invoice")}
        >
          <i style={{ paddingRight: "5px" }} className="fa fa-bell" />
          Send Reminder For Invoice
        </button>
        <button
          className="btn btn-sm btn-success"
          onClick={(e) => sendMail1(indent, "pod")}
        >
          <i style={{ paddingRight: "5px" }} className="fa fa-bell" />
          Send Reminder For POD
        </button>
        <button
          className="btn btn-sm btn-success"
          onClick={(e) => sendMail1(indent, "lr")}
        >
          <i style={{ paddingRight: "5px" }} className="fa fa-bell" />
          Send Reminder For LR
        </button>
      </div>
      <center>
        <span>(Reminder will be sent to transporter POC)</span>
      </center>
    </>
  );
};

export default UploadPOD;
